import "core-js/modules/es.array.push.js";
import vComponentDetail from './components/component.vue';
import vInterfaceDetail from './components/interface.vue';
import vMenu from './components/menu.vue';
import { getAllComponent, getAllInterfaceCategory, getProductList } from '@/api/modules/personal.js';
import { mapMutations } from 'vuex';
export default {
  components: {
    vComponentDetail,
    vInterfaceDetail,
    vMenu
  },
  data() {
    return {
      activeTab: '',
      showTop: false,
      tabList: [{
        name: '云组件',
        key: 'component',
        activeId: '',
        activeGroupCode: [],
        list: []
      }, {
        name: 'API',
        key: 'interface',
        activeId: '',
        activeGroupCode: [],
        list: []
      }],
      showOrderList: false,
      interface_id: '',
      interface_groupCode: '',
      // 接口大分类code
      orderList: {
        component: [],
        interface: []
      },
      contentData: {},
      // 详情页内容数据
      isShowPage: false
    };
  },
  computed: {
    orderListNumber() {
      return this.orderList.component.length + this.orderList.interface.length;
    }
  },
  methods: {
    ...mapMutations({
      setProductList: 'user/setProductList'
    }),
    // 获取产品类型
    getProductType() {
      getProductList().then(res => {
        if (res.code === 1) {
          this.setProductList(res.result);
          if (res.result.length === 0) {
            this.isShowPage = false;
          } else {
            this.isShowPage = true;
            let arr = [];
            res.result.forEach(o => {
              if (o.product_code === 'interface') {
                this.getInterfaceList();
              }
              arr.push(...this.tabList.filter(item => {
                if (item.key === o.product_code) {
                  // item.name = o.product_name;
                  return item.key === o.product_code;
                }
              }));
            });
            this.tabList = arr;
            // this.tabList.forEach(())
            this.activeTab = this.$route.query.type === 'category' ? 'interface' : this.$route.query.type || this.tabList[0].key;
            // this.activeTab = 'interface';
          }
        }
      });
    },
    // 获取id
    getActiveid(type) {
      let id = '';
      this.tabList.forEach(item => {
        if (item.key === type) {
          id = item.activeId;
        }
      });
      return id;
    },
    // 获取接口分类Code
    getActiveGroupCode(type) {
      let id = [];
      this.tabList.forEach(item => {
        if (item.key === type) {
          id = item.activeGroupCode;
        }
      });
      return id[0];
    },
    // 获取组件列表
    getAllComponentList() {
      return getAllComponent().then(res => {
        if (res.code === 1 && res.result.length !== 0) {
          res.result.forEach(item => {
            this.tabList.forEach(ov => {
              if (ov.key === 'component') {
                ov.list.push(item);
              }
            });
          });
          // 如果传参中指定选中了某个分组的组件，则指定的组件为选中状态，否则默认第一个组件为选中状态
          if (this.$route.query.type === 'component' && this.$route.query._id && this.$route.query.group_code) {
            this.tabList.forEach(ov => {
              if (ov.key === 'component') {
                ov.activeId = this.$route.query._id;
                ov.activeGroupCode.push(this.$route.query.group_code);
              }
            });
          } else {
            // this.tabList[0].activeId = res.result[0].list[0]._id;
            // this.tabList[0].activeGroupCode.push(res.result[0].group_code);
            this.tabList.forEach(ov => {
              if (ov.key === 'component') {
                ov.activeId = res.result[0].list[0]._id;
                ov.activeGroupCode.push(res.result[0].group_code);
              }
            });
          }
        }
      });
    },
    // 获取接口列表
    getInterfaceList() {
      return getAllInterfaceCategory().then(res => {
        if (res.code === 1 && res.result.length !== 0) {
          res.result.forEach(item => {
            this.tabList.forEach(ov => {
              if (ov.key === 'interface') {
                ov.list.push(item);
              }
            });
          });
          // 如果传参中指定选中了某个分组的组件，则指定的组件为选中状态，否则默认第一个组件为选中状态
          if (this.$route.query.group_code && this.$route.query.type === 'category' || this.$route.query.type === 'interface' && this.$route.query._id && this.$route.query.group_code) {
            this.tabList.forEach(ov => {
              if (ov.key === 'interface') {
                // ov.activeId = this.$route.query._id;
                ov.activeGroupCode.splice(0, 1, this.$route.query.group_code);
                this.contentData = Object.assign({}, ...this.tabList[1].list.filter(item => item.group_code === decodeURIComponent(this.$route.query.group_code)));
              }
            });
            // this.interface_groupCode = this.$route.query.group_code;
          } else {
            // 默认选择第一个分组 但是不选择第一个接口
            this.tabList.forEach(ov => {
              if (ov.key === 'interface') {
                ov.activeGroupCode.push(res.result[0].group_code);
              }
            });
            this.contentData = this.tabList[1].list[0];
          }
        }
      });
    },
    // 切换组件&接口Tab
    changeTab(activeTab) {
      if (this.$route.query.type) {
        this.$router.replace({
          name: 'details',
          params: {
            type: activeTab
          }
        });
      }
      this.activeTab = activeTab;
    },
    // 切换分组折叠状态
    changeCollapsed({
      group_code
    }) {
      // this.handleScroll();
      let index = 0;
      if (this.tabList.length > 1) {
        this.tabList.forEach((item, i) => {
          if (item.key === this.activeTab) {
            index = i;
          }
        });
      }
      // 组件的和接口的区分，接口的需要做成手风琴模式
      if (this.activeTab === 'component') {
        const group_index = this.tabList[index].activeGroupCode.indexOf(group_code);
        if (group_index !== -1) {
          this.tabList[index].activeGroupCode.splice(group_index, 1);
        } else {
          this.tabList[index].activeGroupCode.push(group_code);
        }
      } else {
        this.interface_groupCode = group_code;
        let obj = [];
        obj = this.tabList[1].list.filter(item => item.group_code === group_code);
        if (obj.length > 0) {
          this.contentData = obj[0];
        }
        this.tabList[index].activeId = '';
        this.interface_id = '';
        if (this.tabList[index].activeGroupCode.indexOf(group_code) !== -1 && this.tabList[index].activeGroupCode.length <= 1) {
          this.tabList[index].activeGroupCode = [];
        } else {
          this.tabList[index].activeGroupCode.push(group_code);
          if (this.tabList[index].activeGroupCode.length > 1) {
            this.tabList[index].activeGroupCode = [this.tabList[index].activeGroupCode[this.tabList[index].activeGroupCode.length - 1]];
          }
        }
      }
    },
    // 切换组件&接口展示
    changeDetail({
      activeId,
      group_code
    }) {
      console.log(activeId, group_code);
      let index = 0;
      if (this.tabList.length > 1) {
        this.tabList.forEach((item, i) => {
          if (item.key === this.activeTab) {
            index = i;
          }
        });
      }
      this.tabList[index].activeId = activeId;
      this.tabList[index].activeGroupCode.splice(0);
      this.tabList[index].activeGroupCode.push(group_code);
      this.interface_id = activeId;
      // console.log(this.interface_id, this.tabList[index], '111');
      window.scrollTo(0, 0);
    },
    // 切换订单列表展示与隐藏
    changeShowOrderList(bol) {
      this.showOrderList = bol;
      if (bol) {
        document.addEventListener('click', this.clickOrderListOutSide, false);
      }
    },
    // 判端滚动位置
    handleScroll() {
      let scrollPosition = Math.floor(window.scrollY || document.documentElement.scrollTop);
      let menu = document.querySelector('.detail-menu');
      var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      // 滚动高度
      // var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      // 页面高度
      var documentHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      console.log(menu.offsetTop, scrollPosition, 'ppp');
      if (scrollPosition > 800) {
        this.showTop = true;
      } else {
        this.showTop = false;
      }
    },
    goTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // 平滑滚动效果
      });
    },
    // 点击订单列表外面，关闭订单列表弹窗
    clickOrderListOutSide(e) {
      if (this.$refs.order && this.$refs.orderList && !this.$refs.order.contains(e.target) && !this.$refs.orderList.contains(e.target)) {
        this.showOrderList = false;
      }
    }
  },
  watch: {
    $route: {
      handler(n) {
        var _n$query, _n$query2;
        if ((_n$query = n.query) !== null && _n$query !== void 0 && _n$query._id || (_n$query2 = n.query) !== null && _n$query2 !== void 0 && _n$query2.group_code) {
          var _n$query3, _n$query4, _n$query5, _n$query7, _n$query9;
          let obj = {
            activeId: (_n$query3 = n.query) === null || _n$query3 === void 0 ? void 0 : _n$query3._id,
            group_code: (_n$query4 = n.query) === null || _n$query4 === void 0 ? void 0 : _n$query4.group_code
          };
          if (((_n$query5 = n.query) === null || _n$query5 === void 0 ? void 0 : _n$query5.type) === 'interface') {
            var _n$query6;
            this.interface_id = (_n$query6 = n.query) === null || _n$query6 === void 0 ? void 0 : _n$query6._id;
          }
          if (((_n$query7 = n.query) === null || _n$query7 === void 0 ? void 0 : _n$query7.type) === 'category') {
            var _n$query8;
            this.interface_groupCode = decodeURIComponent((_n$query8 = n.query) === null || _n$query8 === void 0 ? void 0 : _n$query8.group_code);
            this.interface_id = '';
            this.contentData = Object.assign({}, ...this.tabList[1].list.filter(item => item.group_code === decodeURIComponent(this.$route.query.group_code)));
          }
          if ((_n$query9 = n.query) !== null && _n$query9 !== void 0 && _n$query9.type) {
            var _n$query10, _n$query11;
            this.activeTab = ((_n$query10 = n.query) === null || _n$query10 === void 0 ? void 0 : _n$query10.type) === 'category' ? 'interface' : (_n$query11 = n.query) === null || _n$query11 === void 0 ? void 0 : _n$query11.type;
          }
          this.changeDetail(obj);
        }
      },
      deep: true,
      immediate: true
    }
  },
  async created() {
    this.getProductType();
    this.getAllComponentList();
    // this.getOrderList();
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.clickOrderListOutSide, false);
    window.removeEventListener('scroll', this.handleScroll);
  }
};